import {computed, unref} from 'vue';
import type {Ref} from 'vue';

export type ClassValue = string | Record<string, any> | ClassValue[];
export type VueClassItem = string | Record<string, any>;
export type VueClassValue = string | VueClassItem[] | Record<string, any>;

type MaybeRef<T> = T | Ref<T>;

function flattenClasses(value: ClassValue | undefined): VueClassItem[] {
  if (value == null) return [];
  if (Array.isArray(value)) return value.flatMap(flattenClasses);

  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed ? [trimmed] : [];
  }

  return [value as Record<string, any>];
}

export function useMergedClass(base: MaybeRef<ClassValue>, user?: MaybeRef<ClassValue>) {
  return computed<VueClassValue>(() => {
    const baseItems = flattenClasses(unref(base));
    const userItems = flattenClasses(user === undefined ? undefined : unref(user));
    return [...baseItems, ...userItems];
  });
}
